import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import TheFoundersEdge from "./sections/TheFoundersEdge";
import TheFirstClassStandard from "./sections/TheFirstClassStandard";
import OurProtectionPortfolio from "./sections/OurProtectionPortfolio";
import TheNewEraOfLifeInsurance from "./sections/TheNewEraOfLifeInsurance";
import EditorsFinancialPicks from "./sections/EditorsFinancialPicks";
import GentleReminders from "./sections/GentleReminders";
import AgencyFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      <TheFoundersEdge />
      <TheFirstClassStandard />
      <OurProtectionPortfolio />
      <TheNewEraOfLifeInsurance />
      <EditorsFinancialPicks />
      <GentleReminders />
      <AgencyFooter />
    </div>;
}